import React, { useEffect, useState } from "react";
import TableComponent from "../../../Components/Table/TableComponent";
import StickyHeadTable from "../../../Components/Table/Material";
import { Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NavigateButton from "../../../Components/UI/Buttons/NavigateButton";
import useApi from "../../../Hooks/useApi";
import BasicTable from "../../../Components/Table/Material";
import { usePagination } from "../../../Hooks/usePagination";
import Common from "../../../Components/Layouts/Common";
import ButtonToolbar from "../../Shared/ButtonToolbar";



const AllProjects = () => {
  const { request } = useApi();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const paginateProps = usePagination();

  const [surveyProjectList, setSurveyProjectList] = useState([]);

  const fetchSurveyProjectList = async () => {
    try {
      const response = await request(
        "GET",
        "/v1/survey/projects/list",
        {},
        "survey_service"
      );
      if (response.content) {
        if (response.content?.length > 0) {
          setSurveyProjectList(
            response.content/* .map((item) => ({
              ...item,
              startDate: new Date(item.startDate).toLocaleDateString(),
              endDate: new Date(item.endDate).toLocaleDateString(),
            })) */
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSurveyProjectList();
  }, [paginateProps.page, paginateProps.rowsPerPage]);

  const columns = [
    {
      id: "projectName",
      label: "Project Name",
      minWidth: 400,
    },

    {
      id: "startDate",
      label: "Start Date",
      minWidth: 170,

      align: "right",
    },
    {
      id: "endDate",
      label: "End Date",
      minWidth: 170,
      align: "right",
    },
  ];

  return (
    <div className=" bg-white relative h-full">
      <Common headline={"Project List"}>
        <div className="h-full">
          <ButtonToolbar
            title={t("project_management.add_project")}
            navigateURL={"/add-project"}
          />
          <BasicTable
            columns={columns}
            data={surveyProjectList}
            paginateProps={paginateProps}
            maxHeight={15000}
          />
        </div>
      </Common>
    </div>
  );
};

export default AllProjects;
